import React from 'react';
import { DemoListPage } from './list';

export const DemosModule = () => {
  return <DemoListPage />;
};
